module.exports = __webpack_public_path__ + "static/media/filterb.fbb2a037.png";